import React from 'react';
import DeleteButton from '../../common/DeleteButton';

function PriSubjectsActions({ subject, deleteSubject, onEdit, t }) {
  return (
    <div className="pri-subject-actions">
      <button
        type="button"
        className="pri-subject-edit-button"
        onClick={() => onEdit(subject)}
        aria-label={`${t('edit')} ${subject.subjectName}`}
        title={t('edit')}
      >
        ✏️
      </button>
      <DeleteButton
        objectId={subject.id}
        objectName={subject.subjectName}
        onDelete={deleteSubject}
      />
    </div>
  );
}

export default PriSubjectsActions;
